import { Honeybadger } from 'configuredModules'
import { ValidationError } from 'helpers/validator/validator'

export default function notifyHoneybadger({ err, action }) {
  // useful for debugging
  if ((EXPORT && !action.skipReport) || ENV === 'development') console.log('ERROR', `${(err.message || err) + '\n' + err.stack}`)
  if (ENV === 'development') {
    console.log('HB payload: ', {
      message: `${action.type === 'EXPAND_PROJECT' ? 'Project did not load - ' : ''}${err.message}`,
      context: {
        actionType: action.type
      }
    })
    return
  }

  if (!(err instanceof ValidationError)) {
    Honeybadger.notify(err, {
      message: `${action.type === 'EXPAND_PROJECT' ? 'Project did not load - ' : ''}${err.message}`,
      context: {
        actionType: action.type
      }
    })
  }

  if (!action.skipThrow && !action.skipReport) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/helpers/notifyHoneybadger.js